import { render } from "./archiveManager.vue?vue&type=template&id=1fc42808&scoped=true"
import script from "./archiveManager.vue?vue&type=script&lang=js"
export * from "./archiveManager.vue?vue&type=script&lang=js"

import "./archiveManager.vue?vue&type=style&index=0&id=1fc42808&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc42808"]])

export default __exports__